// Як заробити монети (власник, 26.10.2026): гравці не розуміли, що монети
// дає справжня кава з автомата, а не сам застосунок. Тому два попапи з
// одним змістом:
//   * CoinsIntro — один раз тому, хто ще не забрав жодного бонусу за каву
//     (app.jsx, /me coins_intro);
//   * CoinsHelp — за «?» у Гаманці, коли завгодно.
// Кадрів у макеті для них немає: шторка й рядки способів — ті самі, що в
// «Попап · не вистачає монет» (NotEnough.jsx).
import { useEffect, useState } from "react";
import { api } from "../api.js";
import { ConfirmSheet } from "./Popup.jsx";
import { Bean, Gold, Silver } from "./Coins.jsx";
import { feature } from "../features.js";

// Скільки монет дає звичайний напій. Бонус-напої не рахуємо: вони дають
// удвічі більше й бувають рідко, а «від 33 до 120» обіцяло б те, чого
// людина в автоматі не побачить.
function useDrinkCoins() {
  const [range, setRange] = useState(null);
  useEffect(() => {
    api.get("/catalog/drinks").then((r) => {
      const coins = (r.drinks ?? []).filter((d) => !d.is_bonus && d.coins > 0).map((d) => d.coins);
      if (coins.length) setRange([Math.min(...coins), Math.max(...coins)]);
    }).catch(() => {});
  }, []);
  return range;
}

const Qr = () => (
  <svg viewBox="0 0 28 28" width="28" height="28" fill="var(--accent)" aria-hidden="true" style={{ flex: "none" }}>
    <path fillRule="evenodd" d="M3 3h9v9H3zm2.5 2.5v4h4v-4zM16 3h9v9h-9zm2.5 2.5v4h4v-4zM3 16h9v9H3zm2.5 2.5v4h4v-4z" />
    <path d="M16 16h3v3h-3zm6 0h3v3h-3zm-3 3h3v3h-3zm-3 3h3v3h-3zm6 0h3v3h-3z" />
  </svg>
);

function Way({ icon, title, sub, accent }) {
  return (
    <div className="earn-row" data-accent={accent || undefined}>
      {icon}
      <div className="earn-main">
        <b>{title}</b>
        <small>{sub}</small>
      </div>
    </div>
  );
}

// Головне — кава й QR після неї: без QR монети за покупку ніхто не отримає.
function CoffeeWays({ range }) {
  return (
    <>
      <Way accent icon={<img src="/assets/drinks/latte.webp" alt="" style={{ width: 30, height: 30 }} />}
           title="Купи каву в нашому автоматі"
           sub={range
             ? <>від {range[0]} до {range[1]} <Gold /> за кожен напій</>
             : <>за кожен напій – <Gold /></>} />
      <Way icon={<Qr />}
           title="Відскануй QR з екрана автомата"
           sub="він з'являється після оплати на 2 хвилини – скануй одразу, і монети впадуть на твій акаунт" />
    </>
  );
}

const FreeWay = () => (
  <Way icon={<Silver w={28} h={29} />}
       title="Безкоштовні завдання"
       sub={<>анкета, опитування про напій і пост у соцмережі дають <Silver /> – вони в Гаманці</>} />
);

export function CoinsIntro({ onClose }) {
  const range = useDrinkCoins();
  return (
    <ConfirmSheet onCancel={onClose} gap={14}>
      <div className="intro-badge">
        <svg viewBox="0 0 24 24" width="22" height="22" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" aria-hidden="true">
          <path d="M12 3 2.5 20h19z" strokeLinejoin="round" /><path d="M12 10v4.5M12 17.3v.2" />
        </svg>
        <span><b>Важливо!</b> Це повідомлення з'являється лише один раз</span>
      </div>
      <div className="intro-title">Монети – за справжню каву</div>
      <div className="short-note">Щоб заробляти монети, купуй каву в нашому автоматі. Ось як це працює:</div>
      <div className="earn-list">
        <CoffeeWays range={range} />
        <FreeWay />
      </div>
      <button className="cta wide" onClick={onClose}>Зрозуміло</button>
    </ConfirmSheet>
  );
}

export function CoinsHelp({ ctx, onClose }) {
  const range = useDrinkCoins();
  return (
    <ConfirmSheet onCancel={onClose} closable gap={12}>
      <div className="short-title">Як заробити монети</div>
      <div className="earn-list">
        <CoffeeWays range={range} />
        <FreeWay />
        <Way icon={<img src="/assets/ui/beans_to_coins.webp" alt="" style={{ width: 26, height: 28 }} />}
             title={<>Обмін <Bean w={15} h={17} /></>}
             sub={<>зерна, які дає кавенятко, міняються на <Gold /> у Магазині</>} />
        <Way icon={<img src="/assets/ui/cowboy_body.webp" alt="" style={{ width: 27, height: 28 }} />}
             title="Продаж одягу на ринку"
             sub={<>інші гравці платять за нього <Gold /></>} />
        {feature(ctx.me, "coin_packs") && (
          <Way icon={<img src="/assets/ui/pack_barrel.webp" alt="" style={{ width: 26, height: 30 }} />}
               title="Набір монет"
               sub={<>купити <Gold /> за гривні – «Поповнити» в Гаманці</>} />
        )}
      </div>
      <div className="earn-foot"><Silver /> і <Gold /> витрачаються однаково, а переказати іншому можна лише <Gold />.</div>
    </ConfirmSheet>
  );
}
